export default (theme) => ({
    root: {},
    container: {
        display: 'flex',
        justifyContent: 'flex-start',
        height: '100%',
    },
    left: {
        height: 'calc(100% - 2px)',
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '36px',
        border: `1px solid ${theme.colors.grey[100]}`,
        borderRadius: 8,
    },
    leftContent: {
        width: 'calc(100% - 24px)',
        height: 'calc(100% - 24px)',
    },
    right: {
        width: 417,
        height: '100%',
    },
    tabs: {},
    filtersTab: {
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
    },
    tabsContainer: {
        height: '40px',
    },
    formContainer: {
        height: 'calc(100% - 40px)',
        width: '100%',
        overflowY: 'auto',
        ...theme.utils.scrollbar,
        boxSizing: 'border-box',
        padding: '12px 0',
    },
    loader: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    crudFields: {
        width: '100%',
    },
    crudFilters: {
        width: '100%',
        height: '100%',
        display: 'block',
    },
    hidden: {
        display: 'none',
    },
});
